import React from 'react';
import './BlockSeparator.css';

export const BlockSeparator = ({ className = '' }) => <div className={`homepage-block-separator ${className}`} />;
